<template>
  <div class="row">
    <div v-if="Object.keys(selectedObjective).length" class="col-12">
      <div class="row mt-3">
        <div class="col">
          <a v-if="selectedObjective.write" @click="openModal(selectedObjective.id, '', 'objective', 'update')" class="btn btn-sm btn-outline-dark" href="#objectiveEditModal" data-bs-toggle="modal">&bull; {{ $t("views.objective.detail.btnEditObjective") }}</a>
        </div>
      </div>

      <div class="row mt-3 align-items-center">
        <div class="col">
          <div class="h3">
            {{ selectedObjective.category === 1 ? selectedObjective.name.toUpperCase() : selectedObjective.name }}
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12">

          <!-- Heading Data-->
          <ul v-if="!selectedObjective.folder" class="list-group list-group-horizontal-md foc-list-header">
            <li class="list-group-item bg-white border-0">
              <div class="foc-list-group-item-label">{{ $t("views.kpi.edit.responsible") }}:</div>
              <div>{{ selectedObjective.responsible.name }}</div>
            </li>
            <li class="list-group-item bg-white border-0">
              <div class="foc-list-group-item-label">{{ $t("views.kpi.structure.validityPeriod") }}:</div>
                <div>{{ formatValidityPeriod(selectedObjective) }}</div>
            </li>
            <li class="list-group-item bg-white border-0">
              <div class="foc-list-group-item-label">{{ $t("views.objective.edit.orgUnit") }}:</div>
              <div>{{ selectedObjective.orgUnitName }}</div>
            </li>
            <li class="list-group-item bg-white border-0">
              <div class="foc-list-group-item-label">{{ $t("views.objective.edit.parentObjective") }}:</div>
              <div>{{ selectedObjective.parentName }}</div>
            </li>
            <li class="list-group-item bg-blue border-0">
              <div class="foc-list-group-item-label">{{ $t("views.objective.edit.currentStatusLabel") }}:</div>
              <span v-if="selectedObjective.status === 'C'"> {{ $t("views.objective.edit.status.C") }} </span>
              <span v-if="selectedObjective.status === 'A'"> {{ $t("views.objective.edit.status.A") }} </span>
              <span v-if="selectedObjective.status === 'F'"> {{ $t("views.objective.edit.status.F") }} </span>
            </li>
          </ul>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">

          <!-- Show KPI Table -->
          <div v-if="selectedObjective.criterion === 'KPI'" class="row">
            <div class="col-12 mb-3">
              <KPITable :kpis="selectedObjective.kpis"></KPITable>
            </div>
          </div>

          <!-- Show Key Result Table -->
          <div v-if="selectedObjective.criterion === 'KRT'" class="row">
            <div class="col-12 mb-3">
              <KeyResultsTable :keyresults="selectedObjective.keyresults"></KeyResultsTable>
            </div>
          </div>

        </div>
      </div>

      <!-- Register Tabs -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header fw-bold">{{ $t("views.objective.detail.headingCard") }}</div>

            <div class="card-body">
              <ul class="nav nav-tabs border-bottom" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-dark active" id="definition-tab" data-bs-toggle="tab" data-bs-target="#definition" type="button" role="tab" aria-controls="definition" aria-selected="false">{{ $t("views.objective.detail.tabDefinition") }}</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-dark" id="reviews-tab" data-bs-toggle="tab" data-bs-target="#reviews" type="button" role="tab" aria-controls="reviews" aria-selected="false">{{ $t("views.objective.detail.tabReviews") }} <span v-if="selectedObjective.reviews.length" class="badge bg-primary">{{ selectedObjective.reviews.length }}</span></button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-dark" id="measures-tab" data-bs-toggle="tab" data-bs-target="#measures" type="button" role="tab" aria-controls="measures" aria-selected="false">{{ $t("views.objective.detail.tabMeasures") }} <span v-if="selectedObjective.measures.length" class="badge bg-primary">{{ selectedObjective.measures.length }}</span></button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-dark" id="relationships-tab" data-bs-toggle="tab" data-bs-target="#relationships" type="button" role="tab" aria-controls="relationships" aria-selected="false"> {{ $t("views.relationships.tabRelationships") }} <span v-if="selectedObjective.relationships.length" class="badge bg-primary">{{ selectedObjective.relationships.length }}</span></button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-dark" id="contribute-objectives-tab" data-bs-toggle="tab" data-bs-target="#contributeObjectives" type="button" role="tab" aria-controls="contributeObjectives" aria-selected="false">{{ $t("views.objective.detail.tabContributeObjectives") }} <span v-if="selectedObjective.contributeObjectives.length" class="badge bg-primary">{{ selectedObjective.contributeObjectives.length }}</span></button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-dark" id="conflicts-tab" data-bs-toggle="tab" data-bs-target="#conflicts" type="button" role="tab" aria-controls="conflicts" aria-selected="false">{{ $t("views.objective.detail.tabConflicts") }} <span v-if="selectedObjective.conflicts.length" class="badge bg-primary">{{ selectedObjective.conflicts.length }}</span></button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-dark" id="trials-tab" data-bs-toggle="tab" data-bs-target="#trials" type="button" role="tab" aria-controls="trials" aria-selected="false">{{ $t("views.objective.detail.tabTrials") }} <span v-if="selectedObjective.trials.length" class="badge bg-primary">{{ selectedObjective.trials.length }}</span></button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link text-dark" id="history-tab" data-bs-toggle="tab" data-bs-target="#history" type="button" role="tab" aria-controls="history" aria-selected="false">{{ $t("views.objective.detail.tabHistory") }} <span v-if="selectedObjective.statusHistory.length" class="badge bg-primary">{{ selectedObjective.statusHistory.length }}</span></button>
                </li>
              </ul>

              <div class="tab-content mt-2">

                <!-- Tab Definition -->
                <div class="tab-pane fade show active" id="definition" role="tabpanel">
                  <div v-if="selectedObjective.description" class="mt-3">
                    <QuillContent :content="selectedObjective.description" />
                  </div>
                  <div v-else class="mt-3 h6">{{ $t("views.objective.detail.emptyDescription") }}</div>

                  <!-- <div>
                    <hr>
                    Status-Datum, Status, Verantwortlich, Bemerkung, Erstellt von
                    <br>
                    <div v-for="status in selectedObjective.statusHistory" :key="'status' + status.id" class="mt-2">
                      {{ formatDate(new Date(status.statusDate)) }} &bull; {{ status.status }} &bull; {{ status.responsible.name }} &bull; {{ status.remarks }} &bull; {{ status.createdBy.name }}
                    </div>
                  </div> -->
                </div>

                <!-- Tab Reviews -->
                <div class="tab-pane fade" id="reviews" role="tabpanel">
                  <div v-if="selectedObjective.write" class="row my-3">
                    <div class="col">
                      <button @click="openModal(false, '', 'review', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#objectiveEditModal">+ {{ $t("general.add") }}</button>
                    </div>
                  </div>
                  <div v-if="selectedObjective.reviews.length">
                    <table class="table">
                      <thead>
                        <tr class="border-dark">
                          <th scope="col">{{ $t("views.objective.detail.reviewDate") }}</th>
                          <th scope="col">{{ $t("views.objective.detail.reviewAssessment") }}</th>
                          <th scope="col">{{ $t("views.objective.detail.reviewConversion") }}</th>
                          <th scope="col">{{ $t("views.objective.detail.reviewPrediction") }}</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="review in selectedObjective.reviews" :key="'review' + review.id">
                          <th scope="row">{{ formatDate(new Date(review.date)) }}</th>
                          <td class="w-50">
                            <div v-html="review.assessment"></div>
                          </td>
                          <td>
                            <div class="progress position-relative border bg-dark border-dark w-50">
                              <span class="progress-label position-absolute start-50 top-50 text-light fw-bold">{{ 25 * review.conversion }}%</span>
                              <div class="progress-bar progress-bar-striped bg-primary" :style="'width: ' + (25 * review.conversion) + '%'" role="progressbar" :aria-valuenow="(25 * review.conversion)" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </td>
                          <td>
                            <span class="badge fw-normal" :class="review.prediction === 'Y' ? 'text-bg-success' : review.prediction === 'D' ? 'text-bg-warning' : 'text-bg-danger'">
                              {{ $t("views.objective.detail.review.prediction." + review.prediction.toLowerCase()) }}
                            </span>
                          </td>
                          <td v-if="selectedObjective.write" class="text-end">
                            <div class="dropdown">
                              <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                <svg class="bi" width="28" height="28" fill="currentColor">
                                  <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                </svg>
                              </a>
                              <ul class="dropdown-menu">
                                <li><a @click="openModal(review.id, formatDate(new Date(review.date)) + ': ' + review.assessment, 'review', 'update')" class="dropdown-item" href="#objectiveEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                <li><a @click="openModal(review.id, formatDate(new Date(review.date)) + ': ' + review.assessment, 'review', 'delete')" class="dropdown-item" href="#objectiveDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="mt-3 h6">{{ $t("views.objective.detail.emptyReviews") }}</div>
                </div>

                <!-- Tab Measures -->
                <div class="tab-pane fade" id="measures" role="tabpanel">
                  <div v-if="selectedObjective.write" class="row my-3">
                    <div class="col">
                      <button @click="openModal(false, '', 'measure', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#objectiveEditModal">+ {{ $t("general.add") }}</button>
                    </div>
                  </div>
                  <div v-if="selectedObjective.measures.length">
                    <table class="table">
                      <thead>
                        <tr class="border-dark">
                          <th scope="col">{{ $t("views.objective.detail.measureTitle") }}</th>
                          <th scope="col">{{ $t("views.objective.detail.measureResponsible") }}</th>
                          <th scope="col">{{ $t("views.objective.detail.measureConversion") }}</th>
                          <th scope="col">{{ $t("views.objective.detail.measureValidFrom") }}</th>
                          <th scope="col">{{ $t("views.objective.detail.measureValidTo") }}</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="measure in selectedObjective.measures" :key="'measure' + measure.id">
                          <td v-tooltip.bottom="{ key: 'tooltip.preview', params: { html: measure.measure } }">{{ measure.title }}</td>
                          <td>{{ measure.responsible.name }}</td>
                          <td>
                            <div class="progress position-relative border bg-dark border-dark w-50">
                              <span class="progress-label position-absolute start-50 top-50 text-light fw-bold">{{ 25 * measure.conversion }}%</span>
                              <div class="progress-bar progress-bar-striped bg-primary" :style="'width: ' + (25 * measure.conversion) + '%'" role="progressbar" :aria-valuenow="(25 * measure.conversion)" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </td>
                          <td>{{ formatDate(new Date(measure.validFrom)) }}</td>
                          <td :class="new Date(measure.validTo) < new Date() ? 'text-danger' : 'text-dark'">{{ formatDate(new Date(measure.validTo)) }}</td>
                          <td v-if="selectedObjective.write" class="text-end">
                            <div class="dropdown">
                              <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                <svg class="bi" width="28" height="28" fill="currentColor">
                                  <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                </svg>
                              </a>
                              <ul class="dropdown-menu">
                                <li><a @click="openModal(measure.id, measure.title, 'measure', 'update')" class="dropdown-item" href="#objectiveEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                <li><a @click="openModal(measure.id, measure.title, 'measure', 'delete')" class="dropdown-item" href="#objectiveDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="mt-3 h6">{{ $t("views.objective.detail.emptyMeasures") }}</div>
                </div>

                <!-- Tab Relationships -->
                <div class="tab-pane fade" id="relationships" role="tabpanel">
                  <div v-if="selectedObjective.relationships.length">
                    <table class="table">
                      <thead>
                        <tr class="border-dark">
                          <th scope="col">{{ $t("views.relationships.headerLabel") }}</th>
                          <th scope="col">{{ $t("views.relationships.headerObject") }}</th>
                          <th scope="col">{{ $t("views.relationships.headerValidFrom") }}</th>
                          <th scope="col">{{ $t("views.relationships.headerValidTo") }}</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="relationship in selectedObjective.relationships" :key="'relationship' + relationship.id">
                          <td v-if="relationship.type === 'strategy'">
                            <div class="cont-icon-org-unit d-inline-block me-1">
                              <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconStrategy'"> <use xlink:href="@/assets/icons/icons.svg#strategy" /> </svg> &nbsp;
                              {{ $t("views.relationships.objectiveStrategy") }}
                            </div>
                          </td>                       <td v-if="relationship.type === 'kpi'">
                            <div class="cont-icon-org-unit d-inline-block me-1">
                              <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconKpi'"> <use xlink:href="@/assets/icons/icons.svg#kpi" /> </svg> &nbsp;
                              {{ $t("views.relationships.objectiveKpi") }}
                            </div>
                          </td>
                          <td v-if="relationship.type === 'strategy'"> <a :href="createLink('strategy', relationship.strategyUuid)" target="_blank"> {{ relationship.name }} </a> </td>
                          <td v-if="relationship.type === 'kpi'">       <a :href="createLink('kpi', relationship.kpiUuid)" target="_blank"> {{ relationship.name }} </a> </td>
                          <td>{{ formatDate(new Date(relationship.validFrom)) }}</td>
                          <td>{{ formatDate(new Date(relationship.validTo)) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="mt-3 h6">{{ $t("views.relationships.noRelationships") }}</div>
                </div>

                <!-- Tab Contribute Objectives -->
                <div class="tab-pane fade" id="contributeObjectives" role="tabpanel">
                  <div v-if="selectedObjective.contributeObjectives.length">
                    <div class="row mt-3">
                      <div class="col-3">
                        <ul class="list-group">
                          <li class="list-group-item list-group-item-success fw-bold border-2">{{ $t("views.objective.detail.review.prediction.y") }}</li>
                          <li v-for="contributeObjective in selectedObjective.contributeObjectives.filter(objective => objective.status === 'Y')"
                              :key="'contributeObjective' + contributeObjective.id" @click="selectObjective(contributeObjective)" class="list-group-item list-group-item-child text-truncate">
                            {{ contributeObjective.name }}
                          </li>
                        </ul>
                      </div>
                      <div class="col-3">
                        <ul class="list-group">
                          <li class="list-group-item list-group-item-warning fw-bold border-2">{{ $t("views.objective.detail.review.prediction.d") }}</li>
                          <li v-for="contributeObjective in selectedObjective.contributeObjectives.filter(objective => objective.status === 'D')"
                              :key="'contributeObjective' + contributeObjective.id" @click="selectObjective(contributeObjective)" class="list-group-item list-group-item-child text-truncate">
                            {{ contributeObjective.name }}
                          </li>
                        </ul>
                      </div>
                      <div class="col-3">
                        <ul class="list-group">
                          <li class="list-group-item list-group-item-danger fw-bold border-2">{{ $t("views.objective.detail.review.prediction.n") }}</li>
                          <li v-for="contributeObjective in selectedObjective.contributeObjectives.filter(objective => objective.status === 'N')"
                              :key="'contributeObjective' + contributeObjective.id" @click="selectObjective(contributeObjective)" class="list-group-item list-group-item-child text-truncate">
                            {{ contributeObjective.name }}
                          </li>
                        </ul>
                      </div>
                      <div class="col-3">
                        <ul class="list-group">
                          <li class="list-group-item fw-bold border-2">{{ $t("views.objective.detail.contributeObjectivesWithoutReviews") }}</li>
                          <li v-for="contributeObjective in selectedObjective.contributeObjectives.filter(objective => objective.status === 'U')"
                              :key="'contributeObjective' + contributeObjective.id" @click="selectObjective(contributeObjective)" class="list-group-item list-group-item-child text-truncate">
                            {{ contributeObjective.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div v-else class="mt-3 h6">{{ $t("views.objective.detail.emptyContributeObjectives") }}</div>
                </div>

                <!-- Tab Conflicts -->
                <div class="tab-pane fade" id="conflicts" role="tabpanel">
                  <div v-if="selectedObjective.write" class="row my-3">
                    <div class="col">
                      <button @click="openModal(false, '', 'conflict', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#objectiveEditModal">+ {{ $t("general.add") }}</button>
                    </div>
                  </div>
                  <div v-if="selectedObjective.conflicts.length">
                    <table class="table">
                      <thead>
                        <tr class="border-dark">
                          <th scope="col">{{ $t("views.objective.detail.conflictDescription") }}</th>
                          <th scope="col">{{ $t("views.objective.detail.conflictStatus") }}</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="conflict in selectedObjective.conflicts" :key="'conflict' + conflict.id">
                          <th v-html="conflict.description" scope="row"></th>
                          <td>
                            <svg class="bi" width="20" height="20" fill="currentColor">
                              <use :class="conflict.status ? 'text-success' : 'text-danger'" xlink:href="@/assets/icons/icons.svg#circle-fill"/>
                            </svg>
                          </td>
                          <td v-if="selectedObjective.write" class="text-end">
                            <div class="dropdown">
                              <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                <svg class="bi" width="28" height="28" fill="currentColor">
                                  <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                </svg>
                              </a>
                              <ul class="dropdown-menu">
                                <li><a @click="openModal(conflict.id, conflict.description, 'conflict', 'update')" class="dropdown-item" href="#objectiveEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                <li><a @click="openModal(conflict.id, conflict.description, 'conflict', 'delete')" class="dropdown-item" href="#objectiveDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="mt-3 h6">{{ $t("views.objective.detail.emptyConflicts") }}</div>
                </div>

                <!-- Tab Trials -->
                <div class="tab-pane fade" id="trials" role="tabpanel">
                  <div v-if="selectedObjective.write" class="row my-3">
                    <div class="col">
                      <button @click="openModal(false, '', 'trial', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#objectiveEditModal">+ {{ $t("general.add") }}</button>
                    </div>
                  </div>
                  <div v-if="selectedObjective.trials.length">
                    <table class="table">
                      <thead>
                        <tr class="border-dark">
                          <th scope="col">{{ $t("views.objective.detail.trialDescription") }}</th>
                          <th scope="col" class="text-center align-middle">{{ $t("views.objective.detail.trialPriority") }}</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="trial in selectedObjective.trials" :key="'trial' + trial.id">
                          <th scope="row">{{ trial.description }}</th>
                          <td v-if="trial.priority === true" class="text-center align-middle">
                            <svg class="bi" width="18" height="18" fill="currentColor"> <use xlink:href="@/assets/icons/icons.svg#check"/> </svg>
                          </td>
                          <td v-else></td>
                          <td v-if="selectedObjective.write" class="text-end">
                            <div class="dropdown">
                              <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                <svg class="bi" width="28" height="28" fill="currentColor">
                                  <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                </svg>
                              </a>
                              <ul class="dropdown-menu">
                                <li><a @click="objectiveFromTrial(trial)" class="dropdown-item" href="#">{{ $t("views.objective.detail.trialGenerateObjective") }}</a></li>
                                <li><a @click="openModal(trial.id, trial.description, 'trial', 'update')" class="dropdown-item" href="#objectiveEditModal" data-bs-toggle="modal">{{ $t("general.update") }}</a></li>
                                <li><a @click="openModal(trial.id, trial.description, 'trial', 'delete')" class="dropdown-item" href="#objectiveDeleteModal" data-bs-toggle="modal">{{ $t("general.delete") }}</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="mt-3 h6">{{ $t("views.objective.detail.emptyTrials") }}</div>
                </div>

                <!-- Tab History -->
                <div class="tab-pane fade" id="history" role="tabpanel">
                  <div v-if="selectedObjective.statusHistory.length">
                    <table class="table">
                      <thead>
                        <tr class="border-dark">
                          <th scope="col">{{ $t("views.objective.edit.statusDate") }}</th>
                          <th scope="col">{{ $t("views.objective.edit.statusCreatedBy") }}</th>
                          <th scope="col">{{ $t("views.objective.edit.statusLabel") }}</th>
                          <th scope="col">{{ $t("views.objective.edit.statusRemarks") }}</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="status in selectedObjective.statusHistory" :key="'status' + status.id">
                          <td>{{ formatDate(new Date(status.statusDate)) }}</td>
                          <td>{{ status.createdBy.name }}</td>
                          <td>
                            <span v-if="status.status === 'C'"> {{ $t("views.objective.edit.status.C") }} </span>
                            <span v-if="status.status === 'A'"> {{ $t("views.objective.edit.status.A") }} </span>
                            <span v-if="status.status === 'F'"> {{ $t("views.objective.edit.status.F") }} </span>
                          </td>
                          <td>{{ status.remarks }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center mt-5">
      <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
      <p v-if="'nodes' in objectives && objectives.nodes.length" class="h5 mt-3">{{ $t("views.objective.structure.helpChooseObjective") }}</p>
      <p v-else class="h5 mt-3">{{ $t("views.objective.structure.helpCreateObjective") }}</p>
    </div>
    <ObjectiveEditModal></ObjectiveEditModal>
    <ObjectiveDeleteModal></ObjectiveDeleteModal>
  </div>
</template>

<script>

import ObjectiveEditModal from './ObjectiveEditModal.vue'
import ObjectiveDeleteModal from './ObjectiveDeleteModal.vue'
import KeyResultsTable from './KeyResultsTable.vue'
import KPITable from './KPITable.vue'
import QuillContent from '@/components/QuillContent.vue'
import * as formatUtils from '../../composables/formatUtils'

export default {
  name: 'ObjectivesManageObjectiveDetail',
  data () {
    return {
      objectiveModalElementId: false,
      objectiveModalKeyResultId: false,
      objectiveModalElementType: '',
      objectiveModalMode: '',
      kpiChart: ''
    }
  },

  components: {
    ObjectiveEditModal,
    ObjectiveDeleteModal,
    KeyResultsTable,
    KPITable,
    QuillContent
  },

  computed: {
    objectives () {
      return this.$parent.objectives
    },
    newObjective () {
      return this.$store.state.newObjective
    },
    selectedObjective () {
      return this.$store.state.selectedObjective
    },
    orgUnitsList () {
      return this.$store.state.orgUnitsList
    },
    contributeObjectivesPos () {
      return this.selectedObjective.contributeObjectives.filter(o => o.status < 6)
    },
    contributeObjectivesNeu () {
      return this.selectedObjective.contributeObjectives.filter(o => o.status > 5 && o.status < 11)
    },
    contributeObjectivesNeg () {
      return this.selectedObjective.contributeObjectives.filter(o => o.status > 10)
    }
  },

  methods: {
    openModal (id, name, elementType, mode) {
      if (id) {
        this.objectiveModalElementId = id
      }
      if (name) {
        this.objectiveModalElementName = name.replace(/<[^>]*>/g, '') // Convert name from html to plaintext
      }
      this.objectiveModalElementType = elementType
      this.objectiveModalMode = mode
    },
    createLink (type, uuid) {
      let url = ''
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      if (type === 'kpi') url = '/monitoring/manage/kpis?id=' + uuid
      return url
    },
    async selectObjective (objective) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getObjective', objective.id).then(() => {
        this.objectiveModalElementId = objective.id
      })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    curRecord (kpi) {
      let curRecord = new Date().getFullYear()
      if (this.selectedObjective.validTo.substring(0, 4) < curRecord) {
        curRecord = this.selectedObjective.validTo.substring(0, 4)
      }

      const foundRecord = kpi.records?.find(record => {
        return parseInt(record.period) === parseInt(curRecord)
      })

      if (foundRecord) {
        const prevYearRecord = kpi.records?.find(record => {
          return parseInt(record.period) === parseInt(curRecord - 1)
        })
        if (prevYearRecord) {
          foundRecord.actualPrev = prevYearRecord.actual
        }
        kpi.displayedPeriod = foundRecord.period
        return foundRecord
      } else {
        return {}
      }
    },
    getProgressStatus (kpi) {
      const record = this.curRecord(kpi)
      if (Object.keys(record).length) {
        let progressStatus = 0
        if (record.forecast !== '' && record.objective !== '') {
          progressStatus = Math.round((this.unFormatNumber(record.forecast) / this.unFormatNumber(record.objective)) * 100)
        }
        return progressStatus
      } else {
        return 0
      }
    },
    objectiveFromTrial (trial) {
      this.newObjective.name = trial.description
      this.newObjective.orgUnit = this.selectedObjective.orgUnit
      this.newObjective.parentId = this.selectedObjective.id
      this.$store.dispatch('updateObjectivesContentView', 'add')
    },
    unFormatNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.unFormatNumber(userLocale, number)
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    },
    formatValidityPeriod (obj) {
      if (!obj.validFrom || !obj.validTo) {
        return this.$t('views.kpi.structure.infinite')
      }

      const from = new Date(obj.validFrom)
      const to = new Date(obj.validTo)

      switch (obj.category) {
        case 0: // Jahresziel
          return from.getFullYear().toString()

        case 1: // Durchbruchsziel (mehrjährig)
          return `${from.getFullYear()} - ${to.getFullYear()}`

        // Quartalsziel
        case 2: {
          const year = from.getFullYear()
          const month = from.getMonth()
          const quarter = Math.floor(month / 3) + 1
          return `${year}-Q${quarter}`
        }

        default: // Fallback: Standardanzeige
          return `${this.formatDate(from)} - ${this.formatDate(to)}`
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.kpi-chart {
  max-height: 200px;
}
.progress-label {
  transform: translate(-50%, -50%);
}
th[scope='row'] {
  font-weight: normal;
}
th, td {
  padding-top: 11px !important;
}
.list-group-item-child {
  cursor: pointer;
}
.list-group-item-child:hover {
  font-weight: bold;
}
.tab-content .progress {
  margin-top: 6px;
}
.select-clean {
  border: none;
  background-color: transparent;
  padding-left: 0;
  padding-right: 18px; /* Platz für das Icon */
  box-shadow: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23666'%3E%3Cpath d='M2 4l4 4 4-4'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 12px;
}
.select-clean:focus {
  outline: none;
  box-shadow: none;
}

</style>
